var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.scan}},[_vm._v("扫码")]),_c('el-button',{on:{"click":_vm.link}},[_vm._v("跳转")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }